module.exports = __webpack_public_path__ + "resource/img/edit.9e1b0a83.svg";